var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPayment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 12,
    viewBox: "0 0 15 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 7.6875C2.85082 7.6875 2.70774 7.74676 2.60225 7.85225C2.49676 7.95774 2.4375 8.10082 2.4375 8.25C2.4375 8.39918 2.49676 8.54226 2.60225 8.64775C2.70774 8.75324 2.85082 8.8125 3 8.8125H7.5C7.64918 8.8125 7.79226 8.75324 7.89775 8.64775C8.00324 8.54226 8.0625 8.39918 8.0625 8.25C8.0625 8.10082 8.00324 7.95774 7.89775 7.85225C7.79226 7.74676 7.64918 7.6875 7.5 7.6875H3Z",
    fill: "#1A1A1A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.25 0C1.65326 0 1.08097 0.237053 0.65901 0.65901C0.237053 1.08097 0 1.65326 0 2.25V9.75C0 10.3467 0.237053 10.919 0.65901 11.341C1.08097 11.7629 1.65326 12 2.25 12H12.75C13.3467 12 13.919 11.7629 14.341 11.341C14.7629 10.919 15 10.3467 15 9.75V2.25C15 1.65326 14.7629 1.08097 14.341 0.65901C13.919 0.237053 13.3467 0 12.75 0H2.25ZM12.75 1.125H2.25C1.95163 1.125 1.66548 1.24353 1.4545 1.4545C1.24353 1.66548 1.125 1.95163 1.125 2.25V3.1875H13.875V2.25C13.875 1.95163 13.7565 1.66548 13.5455 1.4545C13.3345 1.24353 13.0484 1.125 12.75 1.125ZM1.125 9.75V4.3125H13.875V9.75C13.875 10.0484 13.7565 10.3345 13.5455 10.5455C13.3345 10.7565 13.0484 10.875 12.75 10.875H2.25C1.95163 10.875 1.66548 10.7565 1.4545 10.5455C1.24353 10.3345 1.125 10.0484 1.125 9.75Z",
    fill: "#1A1A1A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayment);
export default __webpack_public_path__ + "static/media/payment.e016d2147f613b031f70187fdef0decb.svg";
export { ForwardRef as ReactComponent };